import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesCreateComponent } from './messages-create/messages-create.component';
import { MessagesCreateNewComponent } from './messages-create-new/messages-create-new.component';
import { MessageThreadsComponent } from './message-threads/message-threads.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { QuillModule } from 'ngx-quill';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { BytesModule } from 'app/pipes/bytes/bytes.module';
import { AlertModule } from 'app/components/alert/alert.module';
import { DocumentPickerModule } from './document-picker/document-picker.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragonDropDirective } from './dnd.directive';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { TruncateModule } from 'app/pipes/truncate/truncate-pipe.module';
import { MessageThreadComponent } from './message-thread/message-thread.component';
import { MessageComponent } from './message-thread/message/message.component';
import { MessagesWrapperComponent } from './messages-wrapper/messages-wrapper.component';
import { SmsModule } from './../sms/sms.module';
import { ChatModule } from './../chat/chat.module';
import { TemplatePickerModule } from 'app/modules/template-picker/template-picker.module';
import { MessageThreadsDialogComponent } from './message-threads-dialog/message-threads-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { EmailSmartComponent } from './messages-wrapper/email-smart/email-smart.component';
import { EmailListComponent } from './messages-wrapper/email-smart/email-list/email-list.component';
import { EmailContentComponent } from './messages-wrapper/email-smart/email-content/email-content.component';
import { InboxEmailMessageComponent } from './messages-wrapper/email-smart/email-content/inbox-email-message/inbox-email-message.component';
import { TimeAgoModule } from 'app/pipes/time-ago/time-ago-pipe.module';
import { EmailRecipientComponent } from './messages-create-new/email-recipient/email-recipient.component';
import { RecipientMenuComponent } from './messages-create-new/recipient-menu/recipient-menu.component';
import { LendioDirectoryDialogComponent } from './messages-wrapper/email-smart/lendio-directory-dialog/lendio-directory-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { EmailAlertComponent } from './messages-wrapper/email-alert/email-alert.component';
import { InboxEmailListComponent } from './messages-wrapper/email-smart/email-list/inbox-email-list/inbox-email-list.component';
import { MarketingEmailListComponent } from './messages-wrapper/email-smart/email-list/marketing-email-list/marketing-email-list.component';
import { MarketingEmailMessageComponent } from './messages-wrapper/email-smart/email-content/marketing-email-message/marketing-email-message.component';


@NgModule({
  declarations: [
    MessagesCreateComponent,
    MessagesCreateNewComponent,
    MessageThreadsComponent,
    DragonDropDirective,
    MessageThreadComponent,
    MessageComponent,
    MessagesWrapperComponent,
    MessageThreadsDialogComponent,
    EmailSmartComponent,
    EmailListComponent,
    InboxEmailListComponent,
    MarketingEmailListComponent,
    EmailContentComponent,
    InboxEmailMessageComponent,
    MarketingEmailMessageComponent,
    EmailRecipientComponent,
    RecipientMenuComponent,
    LendioDirectoryDialogComponent,
    EmailAlertComponent
  ],
  imports: [
    AlertModule,
    SmsModule,
    ChatModule,
    BytesModule,
    CommonModule,
    DocumentPickerModule,
    EmojiModule,
    FormsModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    MatChipsModule,
    MatTabsModule,
    MatListModule,
    MatRadioModule,
    MatCardModule,
    MatDividerModule,
    PickerModule,
    ReactiveFormsModule,
    ScrollingModule,
    TemplatePickerModule,
    TimeAgoModule,
    TruncateModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          [ 'bold', 'italic'],
          [{'list': 'ordered'}, {'list': 'bullet'}]
        ]
      }
    })
  ],
  exports: [
    MessageThreadsComponent,
    MessageThreadComponent,
    MessagesCreateComponent,
    MessagesCreateNewComponent,
    MessagesWrapperComponent,
    MessageThreadsDialogComponent,
    EmailSmartComponent,
    EmailListComponent,
    EmailContentComponent,
    InboxEmailMessageComponent
  ]
})
export class MessagesModule { }
